import { Avatar, Button, Card, Col, Row, Space, Badge, Typography } from 'antd';
import { PictureOutlined, EditOutlined, SaveOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

export const PokemonHeader = ({
    detalleDatos,
    canEdit,
    onToggleEdit,
    onGoToImagenes
}) => {
    return (
        <Card
            style={{
                borderRadius: '12px',
                border: '1px solid #f0f0f0',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.05)',
                marginBottom: 16,
            }}
        >
            <Row align="middle" justify="space-between">
                <Col>
                    <Space size="large" align="center">
                        <Badge
                            status={canEdit ? "processing" : "success"}
                            offset={[-5, 5]}
                        >
                            <Avatar
                                size={120}
                                src={detalleDatos.imagen}
                                icon={<PictureOutlined />}
                                style={{
                                    border: '3px solid #e6f7ff',
                                }}
                            />
                        </Badge>
                        <div>
                            <Title level={3} style={{ margin: 0 }}>
                                {detalleDatos.poke_nombre || detalleDatos.nombre || `Pokémon #${detalleDatos.id}`}
                            </Title>
                            <Text
                                data-testid="pokemon-header-numero"
                                type="secondary"
                            >
                                ID: {detalleDatos.id} • Número: {detalleDatos.poke_numero_pokedex || 'N/A'}
                            </Text>
                        </div>
                    </Space>
                </Col>
                <Col>
                    <Space direction="vertical" size="middle">
                        <Button
                            icon={<PictureOutlined />}
                            size="large"
                            onClick={onGoToImagenes}
                        >
                            Ver Imágenes
                        </Button>
                        <Button
                            data-testid="btn-editar-pokemon"
                            type={canEdit ? "default" : "primary"}
                            icon={canEdit ? <SaveOutlined /> : <EditOutlined />}
                            size="large"
                            onClick={onToggleEdit}
                        >
                            {canEdit ? 'Cancelar' : 'Editar Pokémon'}
                        </Button>
                    </Space>
                </Col>
            </Row>
        </Card>
    );
};
